export type QualityLevel = 'high' | 'medium' | 'low'

export interface PerformanceSample {
  readonly averageFrameMs: number
  readonly p95FrameMs: number
  readonly nowSeconds: number
}

export interface QualityChange {
  readonly from: QualityLevel
  readonly to: QualityLevel
  readonly reason: 'frame-pressure' | 'stable-headroom'
}

const ORDER: readonly QualityLevel[] = ['low', 'medium', 'high']
const DOWNGRADE_SAMPLES = 5
const UPGRADE_SAMPLES = 15
const COOLDOWN_SECONDS = 10

export class QualityManager {
  private currentLevel: QualityLevel
  private poorSamples = 0
  private goodSamples = 0
  private cooldownUntil = 0

  public constructor(initialLevel: QualityLevel) {
    this.currentLevel = initialLevel
  }

  public get level(): QualityLevel {
    return this.currentLevel
  }

  public sample(sample: PerformanceSample): QualityChange | null {
    if (sample.averageFrameMs > 19 || sample.p95FrameMs > 24) {
      this.poorSamples += 1
      this.goodSamples = 0
    } else if (sample.averageFrameMs < 13 && sample.p95FrameMs < 16) {
      this.goodSamples += 1
      this.poorSamples = 0
    } else {
      this.goodSamples = 0
      this.poorSamples = 0
    }
    if (sample.nowSeconds < this.cooldownUntil) return null
    if (this.poorSamples >= DOWNGRADE_SAMPLES) return this.shift(-1, 'frame-pressure', sample.nowSeconds)
    if (this.goodSamples >= UPGRADE_SAMPLES) return this.shift(1, 'stable-headroom', sample.nowSeconds)
    return null
  }

  private shift(direction: -1 | 1, reason: QualityChange['reason'], nowSeconds: number): QualityChange | null {
    const currentIndex = ORDER.indexOf(this.currentLevel)
    const nextLevel = ORDER[currentIndex + direction]
    this.poorSamples = 0
    this.goodSamples = 0
    if (nextLevel === undefined) return null
    const change = { from: this.currentLevel, to: nextLevel, reason }
    this.currentLevel = nextLevel
    this.cooldownUntil = nowSeconds + COOLDOWN_SECONDS
    return change
  }
}
